import * as React from 'react';

function SvgArrowDown({ fill = 'currentColor', ...props }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.827 7.12a.833.833 0 011.179 0L10 11.112l3.994-3.994a.833.833 0 111.178 1.179L10.59 12.88a.833.833 0 01-1.179 0L4.827 8.298a.833.833 0 010-1.179z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgArrowDown;
